<template>
  <div>
    <CRow>
      <CCol md="6" lg="4" v-for="(period, i) in dashboard_data" :key=i>
        <dashboard-report  :period="period" :color="(i % 2 === 0 ? 'primary' : 'secondary')" :title="period.period"/>
      </CCol>
    </CRow>
    <CRow class="justify-content-center">
      <CCol md="4">
        <CCard align="center" class="font-lg">
          <VueCtkDateTimePicker
            label="Select Date Range to See Report"
            color="#0097FE"
            v-model="date"
            :only-date=true
            :range=true
            @input="getDatedReport"
          />
          <dashboard-report :period="period" color="secondary" title="Report By Date"
          />
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import DashboardReport from './DashboardReport.vue';
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  components: { DashboardReport },
  name: "Dashboard",
  data() {
    return {
      dashboard_data: {},
      date: "",
      start_date: "",
      end_date: "",
      period: [],
      show_report: false
    };
  },
  created() {
    this.getDashboard();
  },
  methods: {
    getDashboard() {
      this.$axios
        .get(`${ADMIN_URL}/dashboard`)
        .then((response) => {
          this.dashboard_data = response.data.period_data;
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    getDatedReport() {
      this.$axios
        .get(`${ADMIN_URL}/date-ranged-dashboard`, {
          params: {
            start_date: this.date.start,
            end_date: this.date.end,
          },
        })
        .then((response) => {
          this.period = response.data;
          this.show_report = true
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
  },
};
</script>
<style scoped>
</style>
